import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';

export default class CityPicker extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = false;
    this.error = null;
    this.onChange = this.attrs.onChange || (() => {});
    this.country = this.attrs.country || 'CN';
    this.province = this.attrs.province || 'CN-BJ';
    this.city = this.attrs.city || '北京市';
    this.countries = [];
    this.provinces = [];
    this.cities = [];
    this.loadCountries();
  }

  onupdate(vnode) {
    super.onupdate(vnode);
    const newCountry = this.attrs.country || 'CN';
    const newProvince = this.attrs.province || 'CN-BJ';
    const newCity = this.attrs.city || '北京市';
    if (newCountry !== this.country || newProvince !== this.province || newCity !== this.city) {
      this.country = newCountry;
      this.province = newProvince;
      this.city = newCity;
      this.onChange = this.attrs.onChange || (() => {});
      this.loadCountries();
    }
  }

  loadCountries() {
    this.loading = true;
    m.redraw();
    app
      .request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/taro/case/cities/countries',
      })
      .then((r) => {
        this.countries = r.countries || [];
        this.loading = false;
        // 加载当前 country 的 provinces
        this.loadProvinces(this.country);
        m.redraw();
      })
      .catch(() => {
        this.error = '国家列表加载失败';
        this.loading = false;
        m.redraw();
      });
  }

  loadProvinces(countryCode) {
    if (!countryCode) {
      this.provinces = [];
      this.cities = [];
      m.redraw();
      return;
    }
    if (countryCode !== 'CN') {
      this.provinces = [];
      this.loadCities(countryCode, null);
      return;
    }
    app
      .request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/taro/case/cities/provinces?country=CN',
      })
      .then((r) => {
        this.provinces = r.provinces || [];
        this.loading = false;
        // 若已选省份，自动加载 cities
        if (this.province) {
          this.loadCities(countryCode, this.province);
        } else {
          m.redraw();
        }
      })
      .catch(() => {
        this.provinces = [];
        this.loading = false;
        m.redraw();
      });
  }

  loadCities(countryCode, provinceCode) {
    if (!countryCode) {
      this.cities = [];
      m.redraw();
      return;
    }
    let url = app.forum.attribute('apiUrl') + '/taro/case/cities/cities?country=' + encodeURIComponent(countryCode);
    if (provinceCode) {
      url += '&province=' + encodeURIComponent(provinceCode);
    }
    app
      .request({
        method: 'GET',
        url: url,
      })
      .then((r) => {
        this.cities = r.cities || [];
        this.loading = false;
        // 如果当前 city 在加载的城市列表中，自动触发 onChange 回传 cityId
        if (this.city) {
          const matched = this.cities.find((c) => c.name_zh === this.city);
          if (matched) {
            const tz = matched.timezone || '';
            const cityId = matched.id || '';
            this.onChange(this.country, this.province, this.city, tz, cityId);
          }
        }
        m.redraw();
      })
      .catch(() => {
        this.cities = [];
        this.loading = false;
        m.redraw();
      });
  }

  onCountryChange(e) {
    const country = e.target.value;
    this.country = country;
    this.province = '';
    this.city = '';
    this.provinces = [];
    this.cities = [];
    if (country === 'CN') {
      this.loadProvinces(country);
    } else {
      this.loadCities(country, null);
    }
    this.onChange(country, '', '', '');
  }

  onProvinceChange(e) {
    const province = e.target.value;
    this.province = province;
    this.city = '';
    this.cities = [];
    this.loadCities(this.country, province);
    this.onChange(this.country, province, '', '');
  }

  onCityChange(e) {
    const cityName = e.target.value;
    this.city = cityName;
    const cityObj = this.cities.find((c) => c.name_zh === cityName);
    const tz = cityObj ? cityObj.timezone : '';
    const cityId = cityObj ? (cityObj.id || '') : '';
    this.onChange(this.country, this.province, cityName, tz, cityId);
  }

  view() {
    if (this.error) {
      return <div className="TaroCityPicker-error">{this.error}</div>;
    }

    return (
      <div className="TaroCityPicker">
        <div className="TaroCityPicker-inline">
          <div className="TaroCityPicker-field">
            <label>国家</label>
            <select className="FormControl" value={this.country} onchange={(e) => this.onCountryChange(e)}>
              <option value="">-- 国家 --</option>
              {this.countries.map((c) => (
                <option value={c.code}>
                  {c.name_zh}
                </option>
              ))}
            </select>
          </div>

          {this.country === 'CN' ? (
            <div className="TaroCityPicker-field">
              <label>省/市</label>
              <select className="FormControl" value={this.province} onchange={(e) => this.onProvinceChange(e)}>
                <option value="">-- 省份 --</option>
                {this.provinces.map((p) => (
                  <option value={p.code}>
                    {p.name_zh}
                  </option>
                ))}
              </select>
            </div>
          ) : null}

          <div className="TaroCityPicker-field">
            <label>城市</label>
            {this.country === 'CN' && !this.province ? (
              <span className="TaroCityPicker-hint">请先选省份</span>
            ) : (
              <select className="FormControl" value={this.city} onchange={(e) => this.onCityChange(e)}>
                <option value="">-- 城市 --</option>
                {this.cities.map((c) => (
                  <option value={c.name_zh}>
                    {c.name_zh}
                  </option>
                ))}
              </select>
            )}
          </div>
        </div>
      </div>
    );
  }
}
